import { render } from "./TextPlugin.vue?vue&type=template&id=06e46d6e&scoped=true"
import script from "./TextPlugin.vue?vue&type=script&lang=js"
export * from "./TextPlugin.vue?vue&type=script&lang=js"

import "./TextPlugin.vue?vue&type=style&index=0&id=06e46d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e46d6e"]])

export default __exports__